module.exports = __webpack_public_path__ + "static/img/04995547.f68dd080.png";